import { Popup } from "devextreme-react";
import "./ViewAttachment.css";

const ViewAttachmentPopup = ({ viewerOpen, setViewerOpen, fileUrl, fileType,fileName }) => {
  return (
    <Popup
      wrapperAttr={{ class: "custom-attachment-popup" }}
      visible={viewerOpen}
      onHiding={() => setViewerOpen(false)}
      showTitle={true}
      title={`${fileName ? ` ${fileName}` : ""}`}
      minWidth="80%"
      height="100%"
      resizeEnabled={true}
      dragEnabled={true}
      dragOutsideBoundary={true}
      showCloseButton={true}
      hideOnOutsideClick={false}
    >
      <div style={{ width: "100%", height: "100%",padding:"20px" }}>
        {fileType === "application/pdf" ? (
          <iframe src={fileUrl} width="100%" height="100%" style={{ border: "none" ,display: "block"}} />
        ) : fileType?.startsWith("image/") ? (
          <img src={fileUrl} alt="Preview" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
        ) : (
          <div style={{ padding: "20px" }}>Preview not available</div>
        )}
      </div>
    </Popup>
  );
};

export default ViewAttachmentPopup;
